module.exports = __webpack_public_path__ + "static/media/marcas (1).228223c9.jpg";